import React from "react";
import './AdminHistory.scss'
import TabBar from "../../Custom UI/TabBar/TabBar";
import {Translation, withTranslation} from "react-i18next";
import SecondaryHeader from "../../Custom UI/Headers/SecondaryHeader/SecondaryHeader";
import {roleForCompany} from "../../Helpers/CompanyHelpers";
import PaperTrailVersionsList from "../../Lists/PaperTrailVersionsList/PaperTrailVersionsList";

class AdminHistory extends React.Component {
  
  // Instance Variables
  
  
  // Init
  
  constructor(props){
    super(props);
    this.state = {
      tabBarKey:'AUDIT_LOG'
    };
  }

  // Render

  render(){
    const {userId, company, currentRole, getAdminHistories, studyClosed, showPatientSearch} = this.props;
    const {tabBarKey} = this.state;
    const companyRole = roleForCompany(company);
    const adminHistoriesPermissions = ['admin_level_4', 'admin'];
    
    return (
      <div>
        {(adminHistoriesPermissions.includes(currentRole) || adminHistoriesPermissions.includes(companyRole) || studyClosed ) ?
          <div className="main-panel-inner-container">
            {!userId ?
              <div>
                <SecondaryHeader title={<Translation>{ (t, { i18n }) => t('AUDIT_LOG') }</Translation>}/>
                
                <TabBar tabBarTabsArray={[{key:'AUDIT_LOG'}]}
                        initialSelectedTabKey={'AUDIT_LOG'}
                        selectedTabKeyChanged={(aKey) => this.setState({tabBarKey:aKey})}
                />
              </div>
              :
              null
            }
            
            {tabBarKey === 'AUDIT_LOG' ?
              <PaperTrailVersionsList userId={userId}
                                      company={company}
                                      getAdminHistories={getAdminHistories}
                                      studyClosed={studyClosed}
                                      showPatientSearch={showPatientSearch}
              />
              :
              null
            }
          </div>
          :
          <div>
            <Translation>{ (t, { i18n }) => t('CONTACT_ADMIN')}</Translation>
          </div>
        }
      </div>
    );
  }
}

export default withTranslation()(AdminHistory);
